/**
 * @typedef {(typeof FulfillmentMethodEnum)[keyof typeof FulfillmentMethodEnum]} FulfillmentMethodEnumValue
 */

const FulfillmentMethodEnum = Object.freeze({
    COLLECTION: 'collection',
    TABLE_SERVICE: 'tableService',
});

module.exports = FulfillmentMethodEnum;
